import React from 'react';
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {NEW_STUDENTS} from "entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {Link} from "react-router-dom";

export const NewStudentsCart = () => {
    const cabinetData = useAppSelector(getCabinetData)

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{NEW_STUDENTS}</p>
                </div>
            </div>
            {cabinetData?.newStudents && cabinetData?.newStudents.length > 0 ? (
                <div className="info-card-content">
                    {cabinetData?.newStudents.map((student, index) => (
                        <div className="row" key={student.id}>
                            <div className="student-data-box">
                                <div className="avatar">
                                    <img src={student.avatar} alt=""/>
                                </div>
                                <div className="student-data">
                                    <p className="name">
                                        <Link
                                            to={`/groups/${student.groups[0].id}/students-pages/${student.id}`}>{student.title}</Link>
                                    </p>
                                    <p>{student.groups[0].title}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="info-card-content">
                    <NothingYetMessage/>
                </div>
            )}
        </div>
    );
};
